import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_SETTING_ROUTER } from "../../../services/api-config";

export interface SettingItem {
  key: string;
  value: string;
}

// Các key whitelist hiển thị/sửa ở trang Cài đặt hệ thống
export const SETTING_KEY = {
  FAULT_PENALTY: "CONFIG_FAULT_PENALTY", // JSON map theo fault_type → tiền phạt
  FAULT_EXPLAIN_HOURS: "CONFIG_FAULT_EXPLAIN_HOURS", // số giờ cho phép giải trình
  SUPERVISOR_DISPATCH_MINUTES: "CONFIG_SUPERVISOR_DISPATCH_MINUTES", // phút giám sát phải điều phối đơn
  ACCEPT_TIMEOUT: "CONFIG_ACCEPT_TIMEOUT", // phút chờ tài xế xác nhận nhận/giao đơn
  REMINDER_INTERVAL: "CONFIG_REMINDER_INTERVAL", // phút giữa các lần nhắc lại tài xế
  POINT_TO_VND: "CONFIG_POINT_TO_VND", // 1 điểm phạt = ? VND
  FAULT_SLA: "CONFIG_FAULT_SLA", // JSON cấu hình mốc phạt SLA (mốc/giờ/bộ phận/điểm theo 3 lần)
  ITEM_DEBT_DUE_HOURS: "CONFIG_ITEM_DEBT_DUE_HOURS", // giờ được nợ đồ trước khi bị phạt (0 = tắt)
  DELIVERY_LOCATION_MAX_METERS: "CONFIG_DELIVERY_LOCATION_MAX_METERS", // khoảng cách (m) hợp lệ khi hoàn thành giao (mặc định 1000)
  ITEM_DEBT_PENALTY: "CONFIG_ITEM_DEBT_PENALTY", // JSON phạt nợ đồ theo nấc: khoảng nhảy nấc + bộ phận/cá nhân từng nấc
  // Đồng bộ phiếu lỗi sang hệ thống đối tác
  PARTNER_FAULT_SYNC_ENABLED: "CONFIG_PARTNER_FAULT_SYNC_ENABLED", // "1" = bật cron gửi tự động 01:00
  PARTNER_FAULT_SYNC_URL: "CONFIG_PARTNER_FAULT_SYNC_URL", // endpoint đầy đủ của đối tác
  PARTNER_FAULT_SYNC_SECRET: "CONFIG_PARTNER_FAULT_SYNC_SECRET", // secret key ký HMAC-SHA256
} as const;

const SettingService = {
  getAll: () => {
    const { request, baseResponse, loading } = useFetchData.Get<SettingItem[]>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: () => request({ endPoint: API_SETTING_ROUTER.API_ALL }),
      response: baseResponse,
      loading,
    };
  },
  updateAll: () => {
    const { request, baseResponse, loading } = useFetchData.Post<null>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (settings: SettingItem[]) =>
        request({ endPoint: API_SETTING_ROUTER.API_ALL, data: { settings } }),
      response: baseResponse,
      loading,
    };
  },
};

export default SettingService;
